import { Checkbox, FormControlLabel } from "@mui/material";
import { FC } from "react";

import { BulkRecalculateAdvancedOptionsStyled } from "./bulk-recalculate-options.styled";

interface IBulkRecalculateAdvancedOptionsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}

export const BulkRecalculateAdvancedOptionsCheckbox: FC<
  IBulkRecalculateAdvancedOptionsCheckboxProps
> = ({ checked, onChange, label }) => {
  return (
    <BulkRecalculateAdvancedOptionsStyled>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(_, nextChecked) => onChange(nextChecked)}
          />
        }
        label={label}
      />
    </BulkRecalculateAdvancedOptionsStyled>
  );
};
